import type { FaireProductEntity } from "../../entity_types/product";

export const p_8mwhyjnhi9: FaireProductEntity = {
  token: "p_8mwhyjnhi9",
  type: "product",
  name: "Basic Mitten Sets",
  brandToken: "b_1acf21e9",
  brandName: "babysoy Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/120a1800e7a2c9a27ca3aa71f200651eeb198674d4aaaac1604ba1c3bf0c4e57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1948e22ac6b13a1753d222185a3af624f12b4b993f7a9da98d3beea4f24fb46.jpeg",
    "https://cdn.faire.com/fastly/adbe5534c8e877f5cfe6a0b77cfd6b2316b599fcc1a79b8131923d428f7f896a.jpeg",
    "https://cdn.faire.com/fastly/692e8d6f85daa9718d85152fbadeb8190be555722c807e2ddf2b5d56957c2f3a.jpeg",
    "https://cdn.faire.com/fastly/4c08aaf1b8acb93422f202491dcb252395acc54a26b0fbf393eecee8d59afa76.jpeg",
    "https://cdn.faire.com/fastly/0c05e0be89880cd4d6b696e40cb6b69e84e40655e2ffd208a8cce6f2a9bf919d.jpeg",
    "https://cdn.faire.com/fastly/f7937a388a2a384f50fc4c8c28a9ffd4211c445362f4fade7f31702dde11c0f6.jpeg",
    "https://cdn.faire.com/fastly/b00e37d89644c38997bdf71c348fffcd088493881a79a2c9e3f3383c93b9612e.jpeg",
  ],
  priceDollars: 4,
  description:
    "- 50% azlon from soy 50% cotton\n\n- machine wash & dry cold\n\n- set of 3 in different colors\n\nBabies can now match from head to toe to little fists with babysoy's soy soft mittens. Each set comes with 3 sets of gloves. Gentle, thin elastics grips around baby's wrist softly and securely. Perfect for preventing scratches.",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:17.262Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
